module.exports = __webpack_public_path__ + "favicon-32x32.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/favicon-32x32.png
// module id = 369
// module chunks = 0